import React, { useEffect, useState } from "react";
import "./BackgroundVideo.css";

export default function BackgroundVideo({
  video, // { id, start, opacity } | null
  visibleDelayMs = 2000,
  title = "Background video",
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!video) {
      setVisible(false);
      return;
    }

    setVisible(false);
    const t = setTimeout(() => setVisible(true), visibleDelayMs);
    return () => clearTimeout(t);
  }, [video?.id, video?.start, visibleDelayMs]);

  if (!video) return null;

  return (
    <div
      className={`video-bg ${visible ? "show" : ""}`}
      style={{ "--videoOpacity": video.opacity }}
      aria-hidden="true"
    >
      <iframe
        title={title}
        src={`https://www.youtube.com/embed/${video.id}?start=${video.start}&autoplay=1&mute=1&controls=0&showinfo=0&modestbranding=1&rel=0&loop=1&playlist=${video.id}&playsinline=1`}
        frameBorder="0"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowFullScreen={false}
      />
    </div>
  );
}